module.exports = __webpack_public_path__ + "static/media/TejeshArujuna.3984cb23.jpg";